// @owners { team: patients-team }

import { ActionSheetContext, Description, Link, ListDescription } from '@alto/design-system';
import { isToday as isDateToday, parse } from 'date-fns';
import React, { useContext } from 'react';
import { DATE_FORMATS, formatRelativeDate } from '~shared/helpers/date';
import { ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';
import { type OrderTypeContext } from '../../../auto-refill';
import { NextAvailableDateActionSheet } from '../../../next-available-date';

type Props = {
  readonly earliestNextAvailableDate: string;
  readonly earliestDateReason: string;
  readonly prescriptionID: number;
  readonly orderTypeContext: OrderTypeContext;
};

export const NextAvailableDateDescription = ({
  earliestNextAvailableDate,
  earliestDateReason,
  prescriptionID,
  orderTypeContext,
}: Props) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);
  const isToday = isDateToday(parse(earliestNextAvailableDate, DATE_FORMATS.YEAR_MONTH_DAY_DASHED, 0));

  return (
    <ListDescription iconName="calendar-small">
      <Description>
        {`Available ${formatRelativeDate(earliestNextAvailableDate, { abbreviated: true, includeRelative: true })}`}
        {!isToday && (
          <>
            {' '}
            •{' '}
            <Link
              textSize="mini"
              onPress={() => {
                setActiveActionSheet(
                  <NextAvailableDateActionSheet
                    earliestAvailableDate={earliestNextAvailableDate}
                    earliestDateReason={earliestDateReason}
                    prescriptionID={prescriptionID}
                    orderTypeContext={orderTypeContext}
                    analyticsOrigin={ORIGIN_NAMES.CART}
                  />,
                );
              }}
            >
              Details
            </Link>
          </>
        )}
      </Description>
    </ListDescription>
  );
};
